// extracted by mini-css-extract-plugin
export default {"footer":"X3wBD"};